import { saveAs } from 'file-saver';
import JSZip from 'jszip';

export function getExtensionFromType(contentType) {
  if (!contentType) return 'jpg';
  if (contentType.includes('png')) return 'png';
  if (contentType.includes('webp')) return 'webp';
  if (contentType.includes('jpeg')) return 'jpg';
  return 'jpg';
}

export function getBaseNameFromUrl(url, index) {
  const parts = url.split('/');
  const lastPart = parts[parts.length - 1].split('?')[0];
  return lastPart || `image_${index}`;
}

export async function fetchAndPrepareFile(url, index) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to fetch ${url}`);

  const blob = await response.blob();
  const contentType = response.headers.get('Content-Type');
  const ext = getExtensionFromType(contentType);
  const baseName = getBaseNameFromUrl(url, index);
  const fileName = `${baseName}.${ext}`;

  return { fileName, blob };
}

export async function downloadImagesAsZip(urls, zipName = 'images.zip') {
  if (!urls.length) {
    return;
  }

  const zip = new JSZip();

  const promises = urls.map(async (url, index) => {
    const { fileName, blob } = await fetchAndPrepareFile(url, index);
    zip.file(fileName, blob);
  });

  await Promise.all(promises);
  const content = await zip.generateAsync({ type: 'blob' });
  saveAs(content, zipName);
}
